<template>    
    <BaseModal
    :id="'static'"
    :title="title"
    :size="'lg'"
    :message="message"
    :disable_close="true">

    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb"/>
    </template>

    <template v-slot:content>
        <form class="row ml-0 mr-0 mb-0 mt-2" @submit.prevent="form_submit()">
            <div class="col-12">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <label class="modal-label active mt-4"> {{form_data.template_permissions.length}} out of {{ countTotalPermissions }} permissions given</label>
                <div style="max-height:35rem" class="overflow-auto ml-0 mr-0 mb-0 mt-2 shadow-sm p-3">
                    <div class="row mb-0" v-for="(item, i) in permissions"  :key="i">
                        <b class="ml-1">{{ countPermissionsByModule(i)[0] + ' out of ' + countPermissionsByModule(i)[1] + ' permissions given' }}</b>
                        <div class="custom-control custom-checkbox d-block col-md-12 ml-2" >
                            <span>
                                <input :id="`theadcheckForm${item.module}`"  type="checkbox" class="custom-control-input ml-2" @change="selectAll(item, $event)" :ref="`theadcheckForm${item.module}`"/>
                                <label :for="`theadcheckForm${item.module}`" class="custom-control-label ml-2" v-html="'Check all'"/>
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckFormWrite${item.module}`"  type="checkbox" class="custom-control-input" @change="selectAll(item, $event , 'write')" :ref="`theadcheckFormWrite${item.module}`"/>
                                <label :for="`theadcheckFormWrite${item.module}`" class="custom-control-label ml-4" v-html="'Check all Write'"/>
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckFormRead${item.module}`"  type="checkbox" class="custom-control-input" @change="selectAll(item, $event, 'read')" :ref="`theadcheckFormRead${item.module}`"/>
                                <label :for="`theadcheckFormRead${item.module}`" class="custom-control-label ml-4" v-html="'Check all Read'"/>
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckFormUpload${item.module}`"  type="checkbox" class="custom-control-input" @change="selectAll(item, $event, 'upload')" :ref="`theadcheckFormUpload${item.module}`"/>
                                <label :for="`theadcheckFormUpload${item.module}`" class="custom-control-label ml-4" v-html="'Check all Uploads'"/>
                            </span>
                        </div>
                        <div class="row associate-permissions ml-0 mr-0">
                            <div class="col-md-2 col-sm-2 associate-permissions__module">
                                <span class="d-flex align-items-center justify-content-center">
                                    {{ item.module }}
                                </span>
                            </div>
                            <div class="col-md-10 col-sm-10 p-0">
                                <div class="row mb-0 ml-0 mr-0 mt-0" :class="item.module">
                                    <div class="col-md-4 col-sm-12 associate-permissions__group" v-for="group_permision in item.group_permissions" :key="group_permision.id">
                                        <div class="formdynamic__item__field associate-permissions__permission">
                                            <label v-html="`${group_permision.name}`" class="modal-label mb-2"/>
                                            <div class="px-0 col-md-12 p-0" v-for="(value, i) in group_permision.permissions" :key="i">
                                            <div class="custom-control custom-checkbox">
                                                <input :id="`${value.name}`" type="checkbox" class="custom-control-input" :value="value.name"  v-model="form_data.template_permissions"/>
                                                <label :for="`${value.name}`" class="custom-control-label ml-2" v-html="value.alias" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CentralButtons /> 
            </div>
        </form>
    </template>
    </BaseModal>
</template>

<script>

import FormDynamic      from    '@/components/FormDynamic.vue'
import BaseModal   from    '@/components/BaseModal'
import FormResources from   './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import CentralButtons from '@/components/CentralButtons'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'
const notyf = new Notyf({duration: 8000})

export default {

    name:   'FormModalTemplatePermissions',
    props: [
        'rest_api',
        'array_options',
        'breadcrumb',
        'permissions',
    ],

    components:{
        BaseModal,
        Breadcrumb,
        FormDynamic,
        CentralButtons
    },

    data(){
        return{
            form_format: FormResources.form_format,
            form_backup: {...FormResources.form_data},
            form_data: FormResources.form_data,
            message: `Here, you can easily allocate specific permissions to your templates to assign to associates. The permissions are conveniently grouped by their parent modules to streamline the assignment process.`,
            index: undefined,
            for_update: false,
            title: 'Associate Permissions',
            notyf,
            per: [] ,
            associate: {},
            is_loading: false,
        }
    },

    methods:{
        reset()
        {
            // this.permissions.forEach(item => {
            //     window.$(`#theadcheckFormWrite${item.module}`).prop('checked', false);
            //     window.$(`#theadcheckFormRead${item.module}`).prop('checked', false);
            //     window.$(`#theadcheckFormUpload${item.module}`).prop('checked', false);
            // })
        },
        selectAll(item, event, type = null)
        {
            let is_checked = event.target.checked

            item.group_permissions.forEach(group_permission => 
            {
                let filter_permissions

                if(!type)
                {
                    filter_permissions = group_permission.permissions
                    window.$(`#theadcheckFormWrite${item.module}`).prop('checked', is_checked);
                    window.$(`#theadcheckFormRead${item.module}`).prop('checked', is_checked);
                    window.$(`#theadcheckFormUpload${item.module}`).prop('checked', is_checked);
                }
                else
                {
                    filter_permissions = group_permission.permissions.filter(item => item.name.toLowerCase().includes(type))
                }

                filter_permissions.forEach(permission => 
                {
                    let index = this.form_data.template_permissions.findIndex(item => item == permission.name)

                    if(is_checked)
                    {
                        if(index == -1)
                        {
                            this.form_data.template_permissions.push(permission.name)
                        }
                    }
                    else
                    {
                        if(index > -1)
                        {
                            this.form_data.template_permissions.splice(index, 1)
                        }
                    }

                })
            })
        },

        countPermissionsByModule(index) 
        {
            let count = 0
            let count_given_permissions = 0;

            this.permissions[index].group_permissions.forEach(group_permission => 
            {
                count += group_permission.permissions.length

                group_permission.permissions.forEach(permission => {
                    let found_index = this.form_data.template_permissions.findIndex(associate_permission => associate_permission == permission.name)
                    if(found_index > -1)
                    {
                        count_given_permissions += 1
                    }
                })
            })

            return [count_given_permissions, count]
        }
    },
    computed: 
    {
        countTotalPermissions()
        {
            let count = 0
            this.permissions.forEach(permission => {
                permission.group_permissions.forEach(group_permission => {
                    count += group_permission.permissions.length
                })
            })
            return count
        }
    }

    
}
</script>